import React from "react";

export const columns = [
    {
        title: "Mã phiếu",
        dataIndex: "maPhieu",
        width: "13%",
        ellipsis: true
    },
    {
        title: "Khách hàng",
        dataIndex: "khachHang",
        width: "20%",
        ellipsis: true
    },
    {
        title: "Ngày cân",
        dataIndex: "ngayCan",
        width: "20%",
        ellipsis: true
    },
    {
        title: "Biển số xe",
        dataIndex: "soXe",
        width: "15%",
        ellipsis: true
    },
    {
        title: "Tên hàng",
        dataIndex: "tenHang",
        width: "15%",
        ellipsis: true
    },
    {
        title: "Khối lượng",
        dataIndex: "hang",
        width: "13%",
        align: "right",
        ellipsis: true
    },
    /*{
        title: "Đơn giá",
        dataIndex: "donGia",
        width: "13%",
        align: "right",
        ellipsis: true
    },*/
    {
        title: "Thành tiền",
        dataIndex: "thanhTien",
        width: "16%",
        align: "right",
        ellipsis: true
    },
    {
        dataIndex: "menu",
        width: '5%',
        onCell: record => {
            return {
                onClick: event => {
                    event.stopPropagation();
                }
            }
        },

    },
];
